export default __webpack_public_path__ + "static/media/logolsbd.656cb7f2.svg";